export default __webpack_public_path__ + "static/media/Group8870.b3036922.svg";